export default "__VITE_ASSET__Dyl_OdZm__"